(function () {
  if (window.__proctersOrderLimitsV1) return;
  window.__proctersOrderLimitsV1 = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ANALGESIC_TAG = 'limit:analgesic-2-packs';
  var ALREADY_IN_CART_MESSAGE = 'Maximum quantity of this product type already in cart';
  var WARNING_TRANSITION_MS = 320;
  var productCache = Object.create(null);
  var lastCart = null;
  var lastAnalgesicTotal = 0;
  var refreshTimer = null;
  var refreshSequence = 0;
  var applyTimer = null;

  function toInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : (fallback || 0);
  }

  function isTrue(value) {
    return String(value || '').toLowerCase() === 'true';
  }

  function messageFor(productMax, analgesic) {
    if (productMax === 1 && analgesic) {
      return 'Maximum 1 pack of this product per order. This product counts towards the 2-pack combined analgesic limit.';
    }
    if (productMax === 2 && analgesic) {
      return 'Maximum 2 packs of this product per order. Relevant analgesic products are limited to 2 packs in total per order.';
    }
    if (productMax === 1) {
      return 'Maximum 1 pack of this product per order.';
    }
    if (productMax === 2) {
      return 'Maximum 2 packs of this product per order.';
    }
    if (analgesic) {
      return 'Maximum 2 packs per order across relevant analgesic products.';
    }
    return '';
  }

  function softDisable(control, disabled) {
    if (!control) return;
    control.classList.toggle('ph-order-limit-disabled', !!disabled);
    if (disabled) {
      control.setAttribute('aria-disabled', 'true');
      control.setAttribute('data-ph-order-limit-disabled', 'true');
    } else {
      control.removeAttribute('data-ph-order-limit-disabled');
      if (!control.disabled) control.removeAttribute('aria-disabled');
    }
  }


  function cartWarningForRow(row) {
    if (!row) return null;
    var warningRow = row.nextElementSibling;
    if (warningRow && warningRow.hasAttribute('data-ph-order-limit-warning-row')) {
      return warningRow.querySelector('[data-ph-order-limit-warning]');
    }
    return row.querySelector('[data-ph-order-limit-warning]');
  }

  function setWarningVisibility(warning, visible) {
    if (!warning) return;

    var warningRow = warning.closest('[data-ph-order-limit-warning-row]');
    if (warning.__phOrderLimitHideTimer) {
      clearTimeout(warning.__phOrderLimitHideTimer);
      warning.__phOrderLimitHideTimer = null;
    }

    if (visible) {
      if (warningRow) warningRow.hidden = false;
      warning.hidden = false;

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          warning.classList.add('is-visible');
        });
      });
      return;
    }

    warning.classList.remove('is-visible');

    if (warning.hidden) {
      if (warningRow) warningRow.hidden = true;
      return;
    }

    warning.__phOrderLimitHideTimer = setTimeout(function () {
      warning.hidden = true;
      if (warningRow) warningRow.hidden = true;
      warning.__phOrderLimitHideTimer = null;
    }, WARNING_TRANSITION_MS);
  }

  function setCartWarning(row, visible) {
    setWarningVisibility(cartWarningForRow(row), visible);
  }

  function setProductWarning(warning, visible) {
    setWarningVisibility(warning, visible);
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');

    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    try {
      if (
        window.Shopify &&
        window.Shopify.actions &&
        typeof window.Shopify.actions.openCart === 'function'
      ) {
        var result = window.Shopify.actions.openCart();
        if (result && typeof result.catch === 'function') result.catch(function () {});
      }
    } catch (error) {}
  }

  function limitedCartRows(root) {
    if (!root || !root.querySelectorAll) return [];
    return Array.prototype.slice.call(root.querySelectorAll('.cart-item[data-ph-order-limit="true"]')).filter(function (row) {
      /* Medicines are excluded from Procters bundles. Do not interfere with
         the separate bundle renderer if a historic cart contains one. */
      return !row.hasAttribute('data-ph-bundle-id');
    });
  }

  function rowInput(row) {
    return row ? row.querySelector('.cart-item__quantity .quantity__input[name="updates[]"], .cart-item__quantity .quantity__input') : null;
  }

  function rowQuantity(row) {
    var input = rowInput(row);
    if (input) return Math.max(0, toInt(input.value, 0));
    return Math.max(0, toInt(row && row.getAttribute('data-ph-line-quantity'), 0));
  }

  function nativeInputMax(input) {
    if (!input) return Infinity;
    var max = input.getAttribute('max');
    if (max === null || max === '') return Infinity;
    var parsed = parseInt(max, 10);
    return Number.isFinite(parsed) ? parsed : Infinity;
  }

  function cartAllowedForRow(row, rows) {
    var productId = String(row.getAttribute('data-ph-limit-product-id') || '');
    var productMax = Math.max(0, toInt(row.getAttribute('data-ph-limit-product-max'), 0));
    var analgesic = isTrue(row.getAttribute('data-ph-limit-analgesic'));
    var allowed = Infinity;

    if (productMax > 0 && productId) {
      var productOther = 0;
      rows.forEach(function (other) {
        if (other === row) return;
        if (String(other.getAttribute('data-ph-limit-product-id') || '') !== productId) return;
        productOther += rowQuantity(other);
      });
      allowed = Math.min(allowed, Math.max(0, productMax - productOther));
    }

    if (analgesic) {
      var analgesicOther = 0;
      rows.forEach(function (other) {
        if (other === row) return;
        if (!isTrue(other.getAttribute('data-ph-limit-analgesic'))) return;
        analgesicOther += rowQuantity(other);
      });
      allowed = Math.min(allowed, Math.max(0, 2 - analgesicOther));
    }

    var input = rowInput(row);
    allowed = Math.min(allowed, nativeInputMax(input));

    return Number.isFinite(allowed) ? Math.max(0, allowed) : Infinity;
  }

  function applyCartRoot(root) {
    var rows = limitedCartRows(root);
    if (!rows.length) return;

    rows.forEach(function (row) {
      var input = rowInput(row);
      if (!input) return;

      var allowed = cartAllowedForRow(row, rows);
      var current = Math.max(0, toInt(input.value, 0));
      var plus = row.querySelector('.cart-item__quantity .quantity__button-increase');

      input.setAttribute('data-ph-order-limit-allowed', Number.isFinite(allowed) ? String(allowed) : '');
      softDisable(plus, Number.isFinite(allowed) && current >= allowed);

      if (!Number.isFinite(allowed) || current < allowed) {
        setCartWarning(row, false);
      }
    });
  }

  function applyCartUi() {
    applyCartRoot(document.getElementById('main-cart'));
    applyCartRoot(document.getElementById('CartDrawer'));
  }

  function cartRootForRow(row) {
    if (!row || !row.closest) return null;
    return row.closest('#main-cart, #CartDrawer');
  }

  function clampCartInput(input) {
    if (!input || !input.closest) return;
    var row = input.closest('.cart-item[data-ph-order-limit="true"]');
    if (!row || row.hasAttribute('data-ph-bundle-id')) return;
    var root = cartRootForRow(row);
    if (!root) return;

    var raw = String(input.value || '').trim();
    if (raw === '') return;

    var desired = toInt(raw, 0);
    var allowed = cartAllowedForRow(row, limitedCartRows(root));

    if (Number.isFinite(allowed) && desired > allowed) {
      input.value = String(allowed);
      setCartWarning(row, true);
    } else if (!Number.isFinite(allowed) || desired < allowed) {
      setCartWarning(row, false);
    }
  }

  function productInfos() {
    return Array.prototype.slice.call(document.querySelectorAll('product-info[data-ph-order-limit-product="true"]'));
  }

  function cartQuantityForProduct(cart, productId) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    var wanted = String(productId || '');
    return cart.items.reduce(function (total, item) {
      return String(item.product_id || '') === wanted
        ? total + Math.max(0, toInt(item.quantity, 0))
        : total;
    }, 0);
  }

  function productData(handle) {
    handle = String(handle || '').trim();
    if (!handle) return Promise.resolve(null);
    if (!productCache[handle]) {
      productCache[handle] = fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' },
        cache: 'force-cache'
      })
        .then(function (response) { return response.ok ? response.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  function productHasTag(data, tag) {
    if (!data) return false;
    var tags = data.tags;
    if (Array.isArray(tags)) return tags.indexOf(tag) !== -1;
    return String(tags || '')
      .split(',')
      .map(function (value) { return value.trim(); })
      .indexOf(tag) !== -1;
  }

  function analgesicProductIdsFromDom() {
    var ids = Object.create(null);
    document.querySelectorAll('.cart-item[data-ph-limit-analgesic="true"][data-ph-limit-product-id]').forEach(function (row) {
      ids[String(row.getAttribute('data-ph-limit-product-id') || '')] = true;
    });
    productInfos().forEach(function (info) {
      if (isTrue(info.getAttribute('data-ph-order-limit-analgesic'))) {
        ids[String(info.getAttribute('data-ph-order-limit-product-id') || '')] = true;
      }
    });
    return ids;
  }

  function analgesicTotalForCart(cart) {
    var infos = productInfos();
    var needsAnalgesic = infos.some(function (info) {
      return isTrue(info.getAttribute('data-ph-order-limit-analgesic'));
    });
    if (!needsAnalgesic || !cart || !Array.isArray(cart.items) || !cart.items.length) {
      return Promise.resolve(0);
    }

    var knownIds = analgesicProductIdsFromDom();
    var checks = cart.items.map(function (item) {
      var quantity = Math.max(0, toInt(item.quantity, 0));
      var productId = String(item.product_id || '');
      if (knownIds[productId]) return Promise.resolve(quantity);

      return productData(item.handle).then(function (data) {
        return productHasTag(data, ANALGESIC_TAG) ? quantity : 0;
      });
    });

    return Promise.all(checks).then(function (quantities) {
      return quantities.reduce(function (total, quantity) { return total + quantity; }, 0);
    });
  }

  function ensureProductWarning(info, form) {
    if (!info || !form) return null;
    var buttons = form.querySelector('.product-form__buttons');
    if (!buttons) return null;

    var warning = buttons.querySelector('[data-ph-order-limit-product-warning]');
    if (!warning) {
      warning = document.createElement('div');
      warning.className = 'ph-order-limit-warning';
      warning.setAttribute('data-ph-order-limit-product-warning', '');
      warning.setAttribute('role', 'note');
      warning.hidden = true;

      var submit = buttons.querySelector('.product-form__submit[name="add"], button[name="add"]');
      var row = submit && submit.parentElement ? submit.parentElement.parentElement : null;
      if (row && row.parentElement === buttons) row.insertAdjacentElement('afterend', warning);
      else buttons.appendChild(warning);
    }

    warning.textContent = messageFor(
      Math.max(0, toInt(info.getAttribute('data-ph-order-limit-product-max'), 0)),
      isTrue(info.getAttribute('data-ph-order-limit-analgesic'))
    );
    return warning;
  }

  function productRemaining(info, cart, analgesicTotal) {
    var productMax = Math.max(0, toInt(info.getAttribute('data-ph-order-limit-product-max'), 0));
    var analgesic = isTrue(info.getAttribute('data-ph-order-limit-analgesic'));
    var productId = info.getAttribute('data-ph-order-limit-product-id');
    var remaining = Infinity;

    if (productMax > 0) {
      remaining = Math.min(remaining, Math.max(0, productMax - cartQuantityForProduct(cart, productId)));
    }
    if (analgesic) {
      remaining = Math.min(remaining, Math.max(0, 2 - analgesicTotal));
    }

    return Number.isFinite(remaining) ? Math.max(0, remaining) : Infinity;
  }

  function applyProductInfo(info, cart, analgesicTotal) {
    var remaining = productRemaining(info, cart || { items: [] }, analgesicTotal || 0);
    info.setAttribute('data-ph-order-limit-remaining', Number.isFinite(remaining) ? String(remaining) : '');

    var forms = Array.prototype.slice.call(info.querySelectorAll('product-form.product-form--buy-buttons form.main-atc-form, form.main-atc-form[data-type="add-to-cart-form"]'));
    forms.forEach(function (form) {
      var warning = ensureProductWarning(info, form);

      var input = form.querySelector('input.quantity__input[name="quantity"]');
      var submit = form.querySelector('.product-form__submit[name="add"], button[name="add"]');
      var plus = input && input.closest('quantity-input')
        ? input.closest('quantity-input').querySelector('.quantity__button-increase')
        : null;

      var selected = input ? Math.max(1, toInt(input.value, 1)) : 1;

      if (input && Number.isFinite(remaining) && remaining > 0 && selected > remaining) {
        input.value = String(remaining);
        selected = remaining;
        warning.setAttribute('data-ph-order-limit-triggered', 'true');
      }

      softDisable(plus, Number.isFinite(remaining) && (remaining <= 0 || selected >= remaining));
      softDisable(submit, Number.isFinite(remaining) && remaining <= 0);

      if (Number.isFinite(remaining) && remaining <= 0) {
        warning.textContent = ALREADY_IN_CART_MESSAGE;
        warning.removeAttribute('data-ph-order-limit-triggered');
        setProductWarning(warning, true);
      } else {
        warning.textContent = messageFor(
          Math.max(0, toInt(info.getAttribute('data-ph-order-limit-product-max'), 0)),
          isTrue(info.getAttribute('data-ph-order-limit-analgesic'))
        );

        if (!Number.isFinite(remaining) || selected < remaining) {
          warning.removeAttribute('data-ph-order-limit-triggered');
          setProductWarning(warning, false);
        } else {
          setProductWarning(warning, warning.getAttribute('data-ph-order-limit-triggered') === 'true');
        }
      }
    });
  }

  function applyProductUi() {
    if (!lastCart) return;
    productInfos().forEach(function (info) {
      applyProductInfo(info, lastCart, lastAnalgesicTotal);
    });
  }

  function refreshProductState() {
    if (!productInfos().length) return Promise.resolve();

    var sequence = ++refreshSequence;
    return fetch(ROOT + 'cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (!cart || sequence !== refreshSequence) return null;
        return analgesicTotalForCart(cart).then(function (analgesicTotal) {
          if (sequence !== refreshSequence) return;
          lastCart = cart;
          lastAnalgesicTotal = analgesicTotal;
          applyProductUi();
        });
      })
      .catch(function () {});
  }

  function scheduleProductRefresh(delay) {
    if (!productInfos().length) return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshProductState, typeof delay === 'number' ? delay : 350);
  }

  function scheduleApply() {
    clearTimeout(applyTimer);
    applyTimer = setTimeout(function () {
      applyCartUi();
      applyProductUi();
    }, 0);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var cartPlus = target.closest('.cart-item[data-ph-order-limit="true"] .quantity__button-increase');
    if (cartPlus) {
      var row = cartPlus.closest('.cart-item[data-ph-order-limit="true"]');
      var root = cartRootForRow(row);
      if (row && root && !row.hasAttribute('data-ph-bundle-id')) {
        var current = rowQuantity(row);
        var allowed = cartAllowedForRow(row, limitedCartRows(root));
        if (Number.isFinite(allowed) && current >= allowed) {
          setCartWarning(row, true);
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          return;
        }
        setTimeout(scheduleApply, 0);
      }
    }

    var cartMinus = target.closest('.cart-item[data-ph-order-limit="true"] .quantity__button-decrease');
    if (cartMinus) {
      var minusRow = cartMinus.closest('.cart-item[data-ph-order-limit="true"]');
      if (minusRow && !minusRow.hasAttribute('data-ph-bundle-id')) {
        setCartWarning(minusRow, false);
        setTimeout(scheduleApply, 0);
      }
    }

    var productMinus = target.closest('product-info[data-ph-order-limit-product="true"] .quantity__button-decrease');
    if (productMinus) {
      var minusInfo = productMinus.closest('product-info[data-ph-order-limit-product="true"]');
      var minusForm = productMinus.closest('form.main-atc-form[data-type="add-to-cart-form"], form.main-atc-form');
      var minusWarning = minusInfo && minusForm ? ensureProductWarning(minusInfo, minusForm) : null;
      var minusRemaining = minusInfo
        ? toInt(minusInfo.getAttribute('data-ph-order-limit-remaining'), 0)
        : 0;

      if (minusRemaining <= 0) {
        if (minusWarning) {
          minusWarning.textContent = ALREADY_IN_CART_MESSAGE;
          minusWarning.removeAttribute('data-ph-order-limit-triggered');
          setProductWarning(minusWarning, true);
        }

        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        openCartDrawer();
        return;
      }

      if (minusWarning) {
        minusWarning.removeAttribute('data-ph-order-limit-triggered');
        setProductWarning(minusWarning, false);
      }
    }

    var productPlus = target.closest('product-info[data-ph-order-limit-product="true"] .quantity__button-increase');
    if (productPlus) {
      var productInfo = productPlus.closest('product-info[data-ph-order-limit-product="true"]');
      var productForm = productPlus.closest('form.main-atc-form[data-type="add-to-cart-form"], form.main-atc-form');
      if (productInfo && productForm) {
        var productInput = productForm.querySelector('input.quantity__input[name="quantity"]');
        var productRemaining = toInt(productInfo.getAttribute('data-ph-order-limit-remaining'), 0);
        var productSelected = productInput ? Math.max(1, toInt(productInput.value, 1)) : 1;

        if (productRemaining > 0 && productSelected >= productRemaining) {
          var productWarning = ensureProductWarning(productInfo, productForm);
          if (productWarning) {
            productWarning.textContent = messageFor(
              Math.max(0, toInt(productInfo.getAttribute('data-ph-order-limit-product-max'), 0)),
              isTrue(productInfo.getAttribute('data-ph-order-limit-analgesic'))
            );
            productWarning.setAttribute('data-ph-order-limit-triggered', 'true');
            setProductWarning(productWarning, true);
          }

          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          return;
        }
      }
    }

    var limitedControl = target.closest('[data-ph-order-limit-disabled="true"]');
    if (limitedControl) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      return;
    }

    var remove = target.closest('.cart-item[data-ph-order-limit="true"] cart-remove-button, .cart-item[data-ph-order-limit="true"] .cart-remove-button');
    if (remove) scheduleProductRefresh(650);
  }, true);

  function handleQuantityEntry(event) {
    var target = event.target;
    if (!target || !target.matches) return;

    if (target.matches('.cart-item[data-ph-order-limit="true"] .quantity__input')) {
      clampCartInput(target);
      scheduleApply();
      if (event.type === 'change') scheduleProductRefresh(650);
      return;
    }

    if (target.matches('product-info[data-ph-order-limit-product="true"] input.quantity__input[name="quantity"]')) {
      var info = target.closest('product-info[data-ph-order-limit-product="true"]');
      if (!info) return;
      var remaining = toInt(info.getAttribute('data-ph-order-limit-remaining'), 0);
      var raw = String(target.value || '').trim();
      var form = target.closest('form.main-atc-form[data-type="add-to-cart-form"], form.main-atc-form');
      var warning = form ? ensureProductWarning(info, form) : null;

      if (raw !== '') {
        var desired = toInt(raw, 1);
        var displayMax = Math.max(1, remaining);

        if (remaining > 0 && desired > displayMax) {
          target.value = String(displayMax);
          if (warning) warning.setAttribute('data-ph-order-limit-triggered', 'true');
        } else if (remaining > 0 && desired < displayMax && warning) {
          warning.removeAttribute('data-ph-order-limit-triggered');
        }
      }
      applyProductUi();
    }
  }

  document.addEventListener('input', handleQuantityEntry, true);
  document.addEventListener('change', handleQuantityEntry, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.closest || !form.matches('form.main-atc-form[data-type="add-to-cart-form"]')) return;
    var info = form.closest('product-info[data-ph-order-limit-product="true"]');
    if (!info) return;

    var remaining = toInt(info.getAttribute('data-ph-order-limit-remaining'), 0);
    var input = form.querySelector('input.quantity__input[name="quantity"]');
    var quantity = input ? Math.max(1, toInt(input.value, 1)) : 1;

    if (remaining <= 0) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      return;
    }

    if (quantity > remaining && input) input.value = String(remaining);

    /* The theme owns the actual add-to-cart request and drawer repaint. We
       only refresh our read-only basket snapshot afterwards. */
    scheduleProductRefresh(450);
    setTimeout(function () { scheduleProductRefresh(0); }, 1100);
  }, true);

  function observeRenderedCart() {
    if (!window.MutationObserver || !document.body) return;
    var pending = false;
    new MutationObserver(function (records) {
      var relevant = records.some(function (record) {
        return Array.prototype.some.call(record.addedNodes || [], function (node) {
          if (!node || node.nodeType !== 1) return false;
          if (node.matches && node.matches('.cart-item, #main-cart, #CartDrawer, product-info[data-ph-order-limit-product="true"]')) return true;
          return !!(node.querySelector && node.querySelector('.cart-item, #main-cart, #CartDrawer, product-info[data-ph-order-limit-product="true"]'));
        });
      });
      if (!relevant || pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        applyCartUi();
        applyProductUi();
      }, 30);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function subscribeToCartUpdates() {
    try {
      if (
        typeof window.subscribe === 'function' &&
        typeof window.PUB_SUB_EVENTS !== 'undefined' &&
        window.PUB_SUB_EVENTS.cartUpdate
      ) {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
          applyCartUi();
          scheduleProductRefresh(120);
        });
      } else if (
        typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.cartUpdate
      ) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          applyCartUi();
          scheduleProductRefresh(120);
        });
      }
    } catch (error) {}
  }

  function boot() {
    applyCartUi();
    productInfos().forEach(function (info) {
      var emptyCart = { items: [] };
      applyProductInfo(info, emptyCart, 0);
    });
    refreshProductState();
    observeRenderedCart();
    subscribeToCartUpdates();
  }

  document.addEventListener('shopify:section:load', function () {
    applyCartUi();
    scheduleProductRefresh(0);
  });

  window.addEventListener('pageshow', function () {
    applyCartUi();
    scheduleProductRefresh(0);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    applyCartUi();
    scheduleProductRefresh(0);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();